import { axios } from "@/plugins/axios";
import { getDataString } from "@/utils";

function getCoach(contractId) {
    return axios.post(
        "?Mode=MeinServicebereich&Function=GetBerater",
        "vertragsnummer=" + contractId
    );
}

// parameters:
// agentId,
// headquarter,
// bereich,
// anrede,
// titel,
// plznocheck,
// vorname,
// zuname,
// email,
// telefon,
// nachricht;
function contactCoach(data = {}) {
    const dataString = getDataString(data);
    return axios.post("?Mode=General&Function=Kontakt", dataString);
}

export { getCoach, contactCoach };
